var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var DefaultController = /** @class */ (function () {
    function DefaultController() {
    }
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "" and http method "GET" to call the back-end.
    
        * @returns {void}
    ******************************************************************************************************/
    DefaultController.GetRoot = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "info" and http method "GET" to call the back-end.
    
        * @returns {void}
    ******************************************************************************************************/
    DefaultController.GetInfo = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("info", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "goto/{key}" and http method "GET" to call the back-end.
    
        * @param {string} key
        * @returns {void}
    ******************************************************************************************************/
    DefaultController.GetRedirect = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("goto/{key}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "gotoauthenticated/{key}" and http method "GET" to call the back-end.
    
        * @param {string} key
        * @returns {void}
    ******************************************************************************************************/
    DefaultController.GetRedirectAuthenticated = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("gotoauthenticated/{key}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/features/v2" and http method "POST" to call the back-end.
    
        * @param {string} url
        * @returns {PlatformFeaturesV2DownloadDto}
    ******************************************************************************************************/
    DefaultController.GetFeaturesV2 = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("url", JSON.stringify(data.url));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/features/v2", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/features" and http method "POST" to call the back-end.
    
        * @param {string} url
        * @returns {PlatformFeaturesDownloadDto}
    ******************************************************************************************************/
    DefaultController.GetFeatures = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("url", JSON.stringify(data.url));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/features", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    return DefaultController;
}());
export { DefaultController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=DefaultController.js.map